import 'babel-polyfill'
import 'es6-promise/auto'

import Vue from 'vue'
import axios from 'axios'
import 'vue-owl-carousel'
import vClickOutside from 'v-click-outside'
import VueAnalytics from 'vue-analytics'
import VScrollLock from 'v-scroll-lock'
import VueMq from 'vue-mq'
// import VueDragTree from 'vue-drag-tree'
// import 'vue-drag-tree/dist/vue-drag-tree.min.css'

import App from './App.vue'
import router from './router'
import store from './store'
import utils from './etc/utils'
import config from './etc/config'
import './filter'
import './directive'
import { HopperPlugin } from './hopper'

// if (config.GA_ID && process.env.NODE_ENV === 'production') {
// Vue.use(VueAnalytics, {
//   id: config.GA_ID,
//   router
// })
// }

axios.defaults.headers.get['Pragma'] = 'no-cache'
axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  function (error) {
    if (error.response.status === 401 && router.currentRoute.name !== 'login') {
      // store.commit('SET_USER_INFO', {})
      router.replace({ name: 'login' })
    }
    // Do something with response error
    return Promise.reject(error)
  }
)

Vue.prototype.$http = axios
Vue.prototype.$utils = utils
Vue.prototype.$config = config

Vue.config.productionTip = false
Vue.use(vClickOutside)
Vue.use(HopperPlugin)
Vue.use(VScrollLock)
Vue.use(VueMq, {
  breakpoints: {
    mobile: 600,
    tablet: 1024,
    desktop: Infinity
  }
})
// Vue.use(VueDragTree)

// const subDomain = 'system'

// if (process.env.NODE_ENV !== 'production') {
//   Vue.prototype.$http.defaults.headers.common['company-id'] = subDomain
// }

// < !--로딩시 웹폰트 출력속도를 위해 최상위에서 시작-- >
// <!-- CSS 점수표 때문에 style.css 보다 플러그인 css가 우선 적용되어야 함 -->

const promise = [
  axios.get('/api/board-metas'),
  axios.get('/api/companys/me'),
  axios.get('/api/banners?useFlag=Y'),
  axios.get('/api/boards/design?useFlag=Y'),
  import('../static/css/font.css'),
  import('../static/css/owl.carousel.css'),
  import('../static/sass/main.scss'),
  import('../main.css')
]
Promise.all(promise)
  .then(res => {
    store.commit('SET_BOARD_META', res[0].data)
    store.commit('SET_COMPANY', res[1].data)
    store.commit('SET_BANNER', res[2].data)
    store.commit('SET_ALL_DESIGN_POSTS', res[3].data)
  })
  .then(res => {
    return axios.get('/api/users/me')
  })
  .then(res => {
    console.log(res)
    store.commit('SET_USER_INFO', res.data)
  })
  .catch(ex => {
    // console.log(ex)
  })
  .then(() => {
    console.log('----------- set ', store.state.company)
    const { gaId = '' } = store.state.company
    console.log('----------- set GA_ID', gaId, gaId === '')
    if (gaId) {
      Vue.use(VueAnalytics, {
        id: gaId,
        router
      })
    }

    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  })
